import { render, staticRenderFns } from "./newTemplate.vue?vue&type=template&id=1d683b9a&scoped=true&"
import script from "./newTemplate.vue?vue&type=script&lang=js&"
export * from "./newTemplate.vue?vue&type=script&lang=js&"
import style0 from "./newTemplate.vue?vue&type=style&index=0&id=1d683b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d683b9a",
  null
  
)

export default component.exports